export type AuthUser = {
  id: string;
  email: string;
};

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
    ...init,
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    let message = res.statusText;
    try {
      const parsed = JSON.parse(text);
      if (typeof parsed?.error === 'string') message = parsed.error;
    } catch {
      if (text) message = text;
    }
    throw new ApiError(message, res.status);
  }
  return (await res.json()) as T;
}

export class ApiError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

export const authApi = {
  me: () => request<AuthUser>('/api/auth/me'),
  signin: (body: { email: string; password: string }) =>
    request<AuthUser>('/api/auth/signin', {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  signup: (body: { email: string; password: string }) =>
    request<AuthUser>('/api/auth/signup', {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  logout: () =>
    request<{ ok: true }>('/api/auth/logout', { method: 'POST' }),
};
